<div class="kardex-page-container">
  <!-- 1. Canonical Page Hero (§4) -->
  <div class="page-hero">
    <div class="hero-main-content">
      <div class="eyebrow-pill">
        <mat-icon class="eyebrow-icon">inventory_2</mat-icon>
        <span>KARDEX E INSUMOS</span>
      </div>
      <h1 class="hero-title">Kardex y Valuación de Insumos</h1>
      <p class="hero-subtitle">
        Visualiza y gestiona la trazabilidad contable continua bajo el método de
        Promedio Ponderado (CUP) por insumo y movimientos históricos generados
      </p>
    </div>

    <div class="hero-actions-content">
      <!-- Active Filters Stat Card (Muted style) -->
      <div
        class="hero-stat-card stat-filters-active"
        *ngIf="getActiveFiltersCount() > 0"
      >
        <span class="stat-label">Filtros Activos</span>
        <strong class="stat-value">{{ getActiveFiltersCount() }}</strong>
      </div>

      <!-- KPI Stock Card -->
      <div
        class="hero-stat-card stat-stock"
        *ngIf="selectedSupplyCode && kardexMovementsList.length > 0"
      >
        <span class="stat-label">Stock Actual</span>
        <strong class="stat-value">
          {{ currentStockQuantityBalance | number: "1.2-2" }}
          <span class="stat-unit" *ngIf="selectedSupplyUnitOfMeasure">{{
            selectedSupplyUnitOfMeasure
          }}</span>
        </strong>
      </div>

      <!-- KPI CUP Card -->
      <div
        class="hero-stat-card stat-cup"
        *ngIf="selectedSupplyCode && kardexMovementsList.length > 0"
      >
        <span class="stat-label">CUP Vigente</span>
        <strong class="stat-value"
          >S/ {{ currentWeightedAverageUnitPriceCUP | number: "1.4-4" }}</strong
        >
      </div>

      <!-- KPI Valuation Card -->
      <div
        class="hero-stat-card stat-valuation"
        *ngIf="selectedSupplyCode && kardexMovementsList.length > 0"
      >
        <span class="stat-label">Valuación Total</span>
        <strong
          class="stat-value"
          [ngClass]="{
            'text-negative': currentTotalInventoryValuationBalance < 0,
          }"
        >
          {{ formatAccountingCurrency(currentTotalInventoryValuationBalance) }}
        </strong>
      </div>

      <!-- Primary Action: Excel Export Button -->
      <button
        mat-flat-button
        class="primary-cta-button"
        *ngIf="kardexMovementsList.length > 0"
        (click)="exportToExcel()"
        id="btn-export-kardex-excel"
      >
        <mat-icon>file_download</mat-icon>
        <span>Exportar a Excel</span>
      </button>
    </div>
  </div>

  <!-- 2. Executive SKU Metadata Banner (Context Bar) -->
  <div class="sku-metadata-banner" *ngIf="selectedSupplyCode">
    <div class="sku-metadata-cells-wrapper">
      <div class="sku-meta-cell">
        <span class="cell-label">CÓDIGO DE EXISTENCIA:</span>
        <span class="cell-value sku-code-pill">{{ selectedSupplyCode }}</span>
      </div>

      <div class="sku-meta-cell" *ngIf="selectedSupplyName">
        <span class="cell-label">SKU / DESCRIPCIÓN:</span>
        <span class="cell-value font-bold">{{ selectedSupplyName }}</span>
      </div>

      <div class="sku-meta-cell" *ngIf="selectedSupplyUnitOfMeasure">
        <span class="cell-label">UNIDAD DE MEDIDA:</span>
        <span class="cell-value font-semibold">{{
          selectedSupplyUnitOfMeasure
        }}</span>
      </div>

      <div class="sku-meta-cell">
        <span class="cell-label">MÉTODO DE VALUACIÓN:</span>
        <span class="cell-value val-method-tag">PROMEDIO PONDERADO (CUP)</span>
      </div>
    </div>

    <div class="sku-meta-actions">
      <button
        mat-stroked-button
        class="btn-refresh-inline"
        [disabled]="isPageLoading"
        (click)="refreshKardexData()"
        id="btn-refresh-kardex-inline"
        matTooltip="Recargar datos del Kardex"
      >
        <mat-icon [class.spinning-icon]="isPageLoading">refresh</mat-icon>
        <span>Actualizar</span>
      </button>
    </div>
  </div>

  <!-- 3. Canonical Filters Card (§5) -->
  <div class="filters-card">
    <div class="filters-header-bar">
      <div class="filters-title-group">
        <div class="title-with-badge">
          <mat-icon class="filters-icon">tune</mat-icon>
          <h2 class="filters-heading">Filtros</h2>
          <span
            class="filters-counter-badge"
            *ngIf="getActiveFiltersCount() > 0"
          >
            {{ getActiveFiltersCount() }}
          </span>
        </div>
        <p class="filters-subtitle">
          Seleccione un insumo (SKU) y refine parámetros por período, tipo de
          movimiento o file.
        </p>
      </div>

      <button
        mat-button
        class="btn-clear-filters"
        *ngIf="getActiveFiltersCount() > 0"
        (click)="resetAllFilters()"
        id="btn-clear-all-filters"
      >
        <mat-icon>filter_alt_off</mat-icon>
        <span>Limpiar filtros</span>
      </button>
    </div>

    <!-- 5-Column Responsive Fields Row -->
    <div class="filters-fields-grid">
      <!-- 1. Primary SKU Autocomplete Input -->
      <mat-form-field appearance="outline" class="filter-field field-sku">
        <mat-label>Insumo (SKU)</mat-label>
        <input
          type="text"
          matInput
          [formControl]="supplySearchControl"
          [matAutocomplete]="supplyAutocomplete"
          placeholder="Ej: VER00002, AJO, PANELA..."
          id="input-kardex-sku-search"
        />
        <mat-icon matPrefix class="field-icon">inventory_2</mat-icon>
        <button
          mat-icon-button
          matSuffix
          *ngIf="supplySearchControl.value"
          (click)="supplySearchControl.setValue('')"
          class="field-clear-btn"
          aria-label="Limpiar selección de SKU"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          #supplyAutocomplete="matAutocomplete"
          [displayWith]="getSupplyOptionDisplayText"
          (optionSelected)="
            onSupplySelectedFromAutocomplete($event.option.value)
          "
        >
          <mat-option
            *ngFor="let supplyItem of filteredSuppliesAutocomplete$ | async"
            [value]="supplyItem"
          >
            <span class="sku-code-tag">{{ supplyItem.codigoInsumo }}</span>
            <span class="sku-name-text">- {{ supplyItem.nombreInsumo }}</span>
            <span class="unit-badge">({{ supplyItem.unidadMedida }})</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- 2. Date Period Select -->
      <mat-form-field appearance="outline" class="filter-field field-period">
        <mat-label>Período de Fecha</mat-label>
        <mat-select
          [formControl]="periodFilterControl"
          id="select-kardex-period"
        >
          <mat-option value="ALL">Todos los Movimientos</mat-option>
          <mat-option value="LAST_7_DAYS">Últimos 7 días</mat-option>
          <mat-option value="LAST_30_DAYS">Últimos 30 días</mat-option>
          <mat-option value="CURRENT_MONTH">Mes Actual</mat-option>
          <mat-optgroup
            label="Mes Específico"
            *ngIf="availableMonthsList.length > 0"
          >
            <mat-option
              *ngFor="let monthEntry of availableMonthsList"
              [value]="'MONTH_' + monthEntry.key"
            >
              {{ monthEntry.label }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
        <mat-icon matPrefix class="field-icon">date_range</mat-icon>
      </mat-form-field>

      <!-- 3. Movement Type Select -->
      <mat-form-field
        appearance="outline"
        class="filter-field field-movement-type"
      >
        <mat-label>Tipo de Movimiento</mat-label>
        <mat-select
          [formControl]="movementTypeFilterControl"
          id="select-kardex-movement-type"
        >
          <mat-option value="ALL">Todos los Tipos</mat-option>
          <mat-option value="INGRESO">Ingresos (Compras)</mat-option>
          <mat-option value="EGRESO_OPERATIVO"
            >Egresos Operativos (Files)</mat-option
          >
          <mat-option value="EGRESO_ADICIONAL">Egresos Adicionales</mat-option>
        </mat-select>
        <mat-icon matPrefix class="field-icon">swap_horiz</mat-icon>
      </mat-form-field>

      <!-- 4. Dynamic File Number Autocomplete -->
      <mat-form-field appearance="outline" class="filter-field field-file">
        <mat-label>Filtrar por File</mat-label>
        <input
          type="text"
          matInput
          [formControl]="fileNumberFilterControl"
          [matAutocomplete]="fileFilterAuto"
          placeholder="Ej: 202605085"
          id="input-kardex-file-filter"
        />
        <mat-icon matPrefix class="field-icon">folder</mat-icon>
        <button
          mat-icon-button
          matSuffix
          *ngIf="fileNumberFilterControl.value"
          (click)="fileNumberFilterControl.setValue('')"
          class="field-clear-btn"
          aria-label="Limpiar filtro de file"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #fileFilterAuto="matAutocomplete">
          <mat-option
            *ngFor="let fileOption of filteredFileNumbersAutocomplete$ | async"
            [value]="fileOption.fileNumber"
          >
            <span class="file-num-tag">File {{ fileOption.fileNumber }}</span>
            <span class="service-name-tag" *ngIf="fileOption.sampleServiceName">
              - {{ fileOption.sampleServiceName }}
            </span>
            <span class="file-count-badge">({{ fileOption.count }} movs)</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- 5. Table Quick Search Input -->
      <mat-form-field appearance="outline" class="filter-field field-search">
        <mat-label>Búsqueda en Tabla</mat-label>
        <input
          type="text"
          matInput
          [formControl]="tableTextSearchControl"
          placeholder="Serie-Número, Proveedor, File..."
          id="input-kardex-quick-search"
        />
        <mat-icon matPrefix class="field-icon">search</mat-icon>
        <button
          mat-icon-button
          matSuffix
          *ngIf="tableTextSearchControl.value"
          (click)="tableTextSearchControl.setValue('')"
          class="field-clear-btn"
          aria-label="Limpiar búsqueda de texto"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Active Filter Chips Footer Bar (§5) -->
    <div class="filters-chips-footer">
      <span class="chips-label">Activos:</span>

      <div
        class="chips-list"
        *ngIf="getActiveFiltersCount() > 0; else noActiveFiltersTemplate"
      >
        <span
          class="filter-chip-pill"
          *ngIf="periodFilterControl.value !== 'ALL'"
        >
          <span class="chip-text">{{
            getPeriodFilterLabel(periodFilterControl.value)
          }}</span>
          <button
            type="button"
            class="chip-remove-btn"
            (click)="periodFilterControl.setValue('ALL')"
            aria-label="Eliminar filtro de período"
          >
            <mat-icon>close</mat-icon>
          </button>
        </span>

        <span
          class="filter-chip-pill"
          *ngIf="movementTypeFilterControl.value !== 'ALL'"
        >
          <span class="chip-text">{{
            getMovementTypeFilterLabel(movementTypeFilterControl.value)
          }}</span>
          <button
            type="button"
            class="chip-remove-btn"
            (click)="movementTypeFilterControl.setValue('ALL')"
            aria-label="Eliminar filtro de tipo de movimiento"
          >
            <mat-icon>close</mat-icon>
          </button>
        </span>

        <span class="filter-chip-pill" *ngIf="fileNumberFilterControl.value">
          <span class="chip-text"
            >File: {{ fileNumberFilterControl.value }}</span
          >
          <button
            type="button"
            class="chip-remove-btn"
            (click)="fileNumberFilterControl.setValue('')"
            aria-label="Eliminar filtro de file"
          >
            <mat-icon>close</mat-icon>
          </button>
        </span>

        <span class="filter-chip-pill" *ngIf="tableTextSearchControl.value">
          <span class="chip-text"
            >Texto: "{{ tableTextSearchControl.value }}"</span
          >
          <button
            type="button"
            class="chip-remove-btn"
            (click)="tableTextSearchControl.setValue('')"
            aria-label="Eliminar filtro de texto"
          >
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </div>

      <ng-template #noActiveFiltersTemplate>
        <span class="no-active-filters-text">Sin filtros activos</span>
      </ng-template>
    </div>
  </div>

  <!-- 4. Collapsible Guía Rápida / Leyenda de la Tabla (§6) -->
  <div class="legend-card" [class.is-collapsed]="!isLegendExpanded">
    <div class="legend-summary-bar" (click)="toggleLegendExpansion()">
      <div class="legend-summary-left">
        <div class="legend-icon-shell">
          <mat-icon>lightbulb</mat-icon>
        </div>
        <div class="legend-title-block">
          <span class="legend-eyebrow">GUÍA RÁPIDA</span>
          <h3 class="legend-heading">Leyenda de la tabla</h3>
          <p class="legend-desc-text">
            Comprobantes SUNAT, códigos de movimiento y sentido cronológico
            oficial.
          </p>
        </div>
      </div>

      <div class="legend-summary-right">
        <span class="legend-pill-tag">Códigos SUNAT</span>
        <button
          type="button"
          class="legend-toggle-btn"
          [attr.aria-expanded]="isLegendExpanded"
          id="btn-toggle-kardex-legend"
        >
          <span>{{
            isLegendExpanded ? "Ocultar leyenda" : "Ver leyenda"
          }}</span>
          <mat-icon class="toggle-arrow">{{
            isLegendExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
          }}</mat-icon>
        </button>
      </div>
    </div>

    <!-- Collapsible 3-Column Content Grid -->
    <div class="legend-expanded-body" *ngIf="isLegendExpanded">
      <div class="legend-columns-grid">
        <!-- Column 1: Entradas -->
        <div class="legend-column">
          <h4 class="legend-column-title">
            Comprobantes de Ingreso (Entradas)
          </h4>
          <p class="legend-column-sub">
            Documentos que incrementan el stock físico y valor del insumo.
          </p>

          <div class="legend-items-list">
            <div class="legend-item-card">
              <span class="document-pill badge-anterior">16 (S.Anterior)</span>
              <div class="item-info">
                <strong class="item-title">Saldo Inicial / Anterior</strong>
                <span class="item-detail">Stock de apertura del período.</span>
              </div>
            </div>

            <div class="legend-item-card">
              <span class="document-pill badge-factura">01 (Factura)</span>
              <div class="item-info">
                <strong class="item-title">Factura de Adquisición</strong>
                <span class="item-detail"
                  >Compra formal de proveedor con RUC.</span
                >
              </div>
            </div>

            <div class="legend-item-card">
              <span class="document-pill badge-boleta">03 (Boleta)</span>
              <div class="item-info">
                <strong class="item-title"
                  >Boleta de Venta / Compra Directa</strong
                >
                <span class="item-detail">Adquisición directa con boleta.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Column 2: Salidas -->
        <div class="legend-column">
          <h4 class="legend-column-title">Comprobantes de Egreso (Salidas)</h4>
          <p class="legend-column-sub">
            Consumos asignados a Files de operaciones turísticas y mermas.
          </p>

          <div class="legend-items-list">
            <div class="legend-item-card">
              <span class="document-pill badge-file">00 (File)</span>
              <div class="item-info">
                <strong class="item-title">Consumo en File</strong>
                <span class="item-detail"
                  >Insumo despachado para servicios de campo.</span
                >
              </div>
            </div>

            <div class="legend-item-card">
              <span class="document-pill badge-otros">00 (Otros)</span>
              <div class="item-info">
                <strong class="item-title">Ajustes o Mermas</strong>
                <span class="item-detail"
                  >Ajuste de inventario físico o deterioro.</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Column 3: Orden de Fecha -->
        <div class="legend-column">
          <h4 class="legend-column-title">Orden de Movimientos (Fecha)</h4>
          <p class="legend-column-sub">
            Sentido de las flechas de ordenamiento en la columna FECHA.
          </p>

          <div class="legend-items-list">
            <div class="legend-item-card">
              <span class="document-pill badge-sort">Flecha ↓ (Abajo)</span>
              <div class="item-info">
                <strong class="item-title">Antiguo a Reciente (FECHA ↓)</strong>
                <span class="item-detail"
                  >Orden cronológico estándar (Totales al final).</span
                >
              </div>
            </div>

            <div class="legend-item-card">
              <span class="document-pill badge-sort">Flecha ↑ (Arriba)</span>
              <div class="item-info">
                <strong class="item-title">Reciente a Antiguo (FECHA ↑)</strong>
                <span class="item-detail"
                  >Inverso cronológico (Totales arriba).</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 5. Background Streaming Live Banner (§7) -->
  <div class="live-streaming-banner" *ngIf="isBackgroundLoadingMore">
    <div class="banner-spinner-shell">
      <mat-spinner diameter="18"></mat-spinner>
    </div>
    <div class="banner-message">
      <span
        >Cargando más movimientos del historial... (<strong>{{
          kardexMovementsList.length
        }}</strong>
        cargados)</span
      >
    </div>
    <div class="banner-progress-track">
      <div class="banner-progress-bar"></div>
    </div>
  </div>

  <!-- 6. Finished Loading Completed Banner (§7) -->
  <div
    class="live-completed-banner"
    *ngIf="
      !isPageLoading &&
      hasFinishedLoadingAllMovements &&
      kardexMovementsList.length > 0
    "
  >
    <div class="completed-content">
      <mat-icon class="completed-check-icon">check_circle</mat-icon>
      <span class="completed-text">
        Historial completo cargado exitosamente (<strong>{{
          kardexMovementsList.length
        }}</strong>
        movimientos).
      </span>
    </div>
    <button
      type="button"
      class="btn-dismiss-completed"
      (click)="dismissCompletionNotificationBanner()"
      aria-label="Cerrar notificación de carga completa"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- 7. Initial State Prompt (No SKU Selected) -->
  <div
    class="initial-state-prompt-card"
    *ngIf="!isPageLoading && !selectedSupplyCode"
  >
    <div class="prompt-icon-shell">
      <mat-icon>inventory_2</mat-icon>
    </div>
    <h3 class="prompt-title">
      Seleccione un Insumo (SKU) para consultar su Kardex
    </h3>
    <p class="prompt-description">
      Para comenzar la auditoría contable, seleccione o busque el insumo deseado
      en el campo
      <strong>Insumo (SKU)</strong> de la barra de filtros por código (ej:
      <code>VER00002</code>) o nombre (ej: <code>AJO</code>).
    </p>
  </div>

  <!-- 8. Skeleton / Loading Initial State (§7) -->
  <div
    class="skeleton-loading-card"
    *ngIf="isPageLoading && kardexMovementsList.length === 0"
  >
    <div class="skeleton-summary-strip">
      <div class="skeleton-icon-shell">
        <mat-icon>hourglass_top</mat-icon>
      </div>
      <div class="skeleton-text-block">
        <span class="skeleton-eyebrow">UN MOMENTO</span>
        <h3 class="skeleton-title">
          Cargando movimientos de
          {{ selectedSupplyName || selectedSupplyCode || "Insumo" }}...
        </h3>
        <p class="skeleton-desc">
          Recuperando registros contables e historial de operaciones.
        </p>
      </div>
      <div class="skeleton-status-pill">Consultando API</div>
    </div>

    <div class="skeleton-progress-line">
      <div class="skeleton-progress-bar"></div>
    </div>

    <div class="skeleton-shimmer-rows">
      <div class="shimmer-row" *ngFor="let index of [1, 2, 3, 4, 5]"></div>
    </div>
  </div>

  <!-- 9. Empty State Banner (§7) -->
  <div
    class="empty-state-card"
    *ngIf="
      !isPageLoading && selectedSupplyCode && kardexMovementsList.length === 0
    "
  >
    <mat-icon class="empty-icon">find_in_page</mat-icon>
    <h3 class="empty-title">No se encontraron movimientos registrados</h3>
    <p class="empty-description">
      No hay registros de ingresos ni egresos para este insumo con los filtros
      seleccionados. Verifique el período o intente seleccionar otro insumo.
    </p>
    <button
      mat-stroked-button
      class="btn-empty-refresh"
      (click)="refreshKardexData()"
    >
      <mat-icon>refresh</mat-icon>
      <span>Actualizar consulta</span>
    </button>
  </div>

  <!-- 10. Table Surface & Wrapper (§7) -->
  <div class="table-surface" *ngIf="kardexMovementsList.length > 0">
    <!-- Toolbar with Record Count & Helper (§7) -->
    <div class="table-toolbar">
      <div class="toolbar-count">
        <mat-icon class="toolbar-icon">table_rows</mat-icon>
        <span class="count-text">
          Mostrando
          <strong>{{ kardexTableDataSource.data.length }}</strong> movimientos
          en esta página
          <ng-container *ngIf="getActiveFiltersCount() > 0">
            (de <strong>{{ totalFilteredMovementsCount }}</strong> filtrados)
          </ng-container>
        </span>
      </div>

      <div class="toolbar-help">
        <mat-icon class="help-icon">info</mat-icon>
        <span>Método de Promedio Ponderado oficial SUNAT.</span>
      </div>
    </div>

    <!-- Paginator Pill at Top -->
    <div class="table-paginator-container">
      <mat-paginator
        [pageSizeOptions]="[10, 25, 50, 100]"
        pageSize="25"
        showFirstLastButtons
        (page)="onPaginatorPageChange($event)"
        aria-label="Seleccionar página de movimientos del Kardex"
        class="kardex-pill-paginator"
      ></mat-paginator>
    </div>

    <!-- Table Wrapper (§7) -->
    <div class="table-wrapper">
      <table
        mat-table
        [dataSource]="kardexTableDataSource"
        matSort
        (matSortChange)="onSortChange($event)"
        class="kardex-mat-table"
        [class.totals-at-top]="dateSortDirection === 'asc'"
      >
        <!-- Movement Date Column -->
        <ng-container matColumnDef="movementDate">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="movementDate"
            class="th-center th-col-date"
          >
            FECHA
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-center td-col-date"
          >
            <span class="date-cell">{{
              displayRawMovementDate(movementRecord.movementDate)
            }}</span>
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-center font-bold text-summary"
          >
            TOTAL x ARTÍCULO:
          </td>
        </ng-container>

        <!-- Document Type Code Column -->
        <ng-container matColumnDef="documentType">
          <th mat-header-cell *matHeaderCellDef class="th-center th-col-type">
            TIPO
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-center td-col-type"
          >
            <span
              class="document-pill"
              [ngClass]="getDocumentBadgeCssClass(movementRecord)"
            >
              {{ getDocumentTypeCode(movementRecord) }}
            </span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Document Serial / Number Column -->
        <ng-container matColumnDef="documentNumber">
          <th mat-header-cell *matHeaderCellDef class="th-center th-col-docnum">
            SERIE-NÚMERO
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-center font-bold td-col-docnum"
          >
            <span class="doc-number-text">{{
              getDocumentNumber(movementRecord)
            }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Reference Detail Info Column: Provider / File / Concept -->
        <ng-container matColumnDef="referenceDetailInfo">
          <th mat-header-cell *matHeaderCellDef class="th-col-concept">
            PROVEEDOR / FILE / CONCEPTO
          </th>
          <td mat-cell *matCellDef="let movementRecord" class="td-concept-cell">
            <!-- Supplier Info Tag -->
            <div
              *ngIf="movementRecord.aybProviderSnapshot?.providerName"
              class="concept-tag tag-provider"
            >
              <div class="icon-shell shell-provider">
                <mat-icon>store</mat-icon>
              </div>
              <div class="tag-body">
                <span class="tag-primary-title">{{
                  movementRecord.aybProviderSnapshot?.providerName
                }}</span>
                <span
                  class="tag-secondary-meta"
                  *ngIf="movementRecord.aybProviderSnapshot?.providerRuc"
                >
                  RUC: {{ movementRecord.aybProviderSnapshot?.providerRuc }}
                </span>
              </div>
            </div>

            <!-- File / Itinerary Tag -->
            <div
              *ngIf="
                movementRecord.itinerarySnapshot?.fileNumber ||
                movementRecord.itineraryId ||
                movementRecord.itineraryServiceSnapshot?.serviceName
              "
              class="concept-tag tag-file"
            >
              <div class="icon-shell shell-file">
                <mat-icon>folder_open</mat-icon>
              </div>
              <div class="tag-body">
                <span class="tag-primary-title">
                  File:
                  {{
                    movementRecord.itinerarySnapshot?.fileNumber ||
                      movementRecord.itineraryId
                  }}
                </span>
                <span
                  class="tag-secondary-meta"
                  *ngIf="
                    movementRecord.itineraryServiceSnapshot?.serviceName ||
                    movementRecord.itineraryServiceSnapshot?.menuName
                  "
                >
                  {{
                    movementRecord.itineraryServiceSnapshot?.serviceName || ""
                  }}
                  <ng-container
                    *ngIf="movementRecord.itineraryServiceSnapshot?.menuName"
                  >
                    - {{ movementRecord.itineraryServiceSnapshot?.menuName }}
                  </ng-container>
                </span>
              </div>
            </div>

            <!-- Outflow Type Tag (for additional outflows) -->
            <div
              *ngIf="
                movementRecord.outflowSnapshot?.outflowType &&
                movementRecord.movementType === 'EGRESO_ADICIONAL'
              "
              class="concept-tag tag-outflow"
            >
              <div class="icon-shell shell-outflow">
                <mat-icon>assignment_turned_in</mat-icon>
              </div>
              <div class="tag-body">
                <span class="tag-primary-title">{{
                  movementRecord.outflowSnapshot?.outflowType
                }}</span>
              </div>
            </div>

            <!-- Concept / Observation Note -->
            <div
              *ngIf="movementRecord.observation"
              class="concept-observation-text"
            >
              {{ movementRecord.observation }}
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- ENTRADAS (INFLOWS): Quantity -->
        <ng-container matColumnDef="inflowQuantity">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-inflow"
          >
            CANT.
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number font-bold"
            [ngClass]="{
              'td-group-inflow': isInflowMovement(movementRecord),
              'text-negative':
                movementRecord.movementQuantityDelta < 0 &&
                isInflowMovement(movementRecord),
              'text-positive':
                movementRecord.movementQuantityDelta >= 0 &&
                isInflowMovement(movementRecord),
            }"
          >
            {{
              isInflowMovement(movementRecord)
                ? formatAccountingQuantity(movementRecord.movementQuantityDelta)
                : "-"
            }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-inflow font-bold"
            [ngClass]="
              periodInflowQuantitySum < 0 ? 'text-negative' : 'text-positive'
            "
          >
            {{
              periodInflowQuantitySum !== 0
                ? formatAccountingQuantity(periodInflowQuantitySum)
                : "-"
            }}
          </td>
        </ng-container>

        <!-- ENTRADAS (INFLOWS): Unit Cost -->
        <ng-container matColumnDef="inflowUnitPrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-inflow"
          >
            COS. UNIT.
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number"
            [ngClass]="{ 'td-group-inflow': isInflowMovement(movementRecord) }"
          >
            {{
              isInflowMovement(movementRecord)
                ? "S/ " + (movementRecord.movementUnitPrice | number: "1.4-4")
                : "-"
            }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-inflow"
          ></td>
        </ng-container>

        <!-- ENTRADAS (INFLOWS): Total Cost -->
        <ng-container matColumnDef="inflowTotalAmount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-inflow"
          >
            COSTO TOTAL
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number font-bold"
            [ngClass]="{
              'td-group-inflow': isInflowMovement(movementRecord),
              'text-negative':
                movementRecord.movementQuantityDelta < 0 &&
                isInflowMovement(movementRecord),
            }"
          >
            {{
              isInflowMovement(movementRecord)
                ? movementRecord.movementQuantityDelta < 0
                  ? formatAccountingCurrency(
                      -movementRecord.movementTotalValuation
                    )
                  : formatAccountingCurrency(
                      movementRecord.movementTotalValuation
                    )
                : "-"
            }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-inflow font-bold"
            [ngClass]="periodInflowCostSum < 0 ? 'text-negative' : ''"
          >
            {{
              periodInflowCostSum !== 0
                ? formatAccountingCurrency(periodInflowCostSum)
                : "-"
            }}
          </td>
        </ng-container>

        <!-- SALIDAS (OUTFLOWS): Quantity -->
        <ng-container matColumnDef="outflowQuantity">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-outflow"
          >
            CANT.
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number font-bold"
            [ngClass]="{
              'td-group-outflow': isOutflowMovement(movementRecord),
              'text-negative': isOutflowMovement(movementRecord),
            }"
          >
            {{
              isOutflowMovement(movementRecord)
                ? (getAbsNumber(movementRecord.movementQuantityDelta)
                  | number: "1.2-2")
                : "-"
            }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-outflow font-bold text-negative"
          >
            {{
              periodOutflowQuantitySum > 0
                ? (periodOutflowQuantitySum | number: "1.2-2")
                : "-"
            }}
          </td>
        </ng-container>

        <!-- SALIDAS (OUTFLOWS): Unit Cost -->
        <ng-container matColumnDef="outflowUnitPrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-outflow"
          >
            COS. UNIT.
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number"
            [ngClass]="{
              'td-group-outflow': isOutflowMovement(movementRecord),
            }"
          >
            {{
              isOutflowMovement(movementRecord)
                ? "S/ " + (movementRecord.movementUnitPrice | number: "1.4-4")
                : "-"
            }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-outflow"
          ></td>
        </ng-container>

        <!-- SALIDAS (OUTFLOWS): Total Cost -->
        <ng-container matColumnDef="outflowTotalAmount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-outflow"
          >
            COSTO TOTAL
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number font-bold"
            [ngClass]="{
              'td-group-outflow': isOutflowMovement(movementRecord),
            }"
          >
            {{
              isOutflowMovement(movementRecord)
                ? "S/ " +
                  (movementRecord.movementTotalValuation | number: "1.2-2")
                : "-"
            }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-outflow font-bold"
          >
            {{
              periodOutflowCostSum > 0
                ? "S/ " + (periodOutflowCostSum | number: "1.2-2")
                : "-"
            }}
          </td>
        </ng-container>

        <!-- SALDO FINAL: Quantity Balance -->
        <ng-container matColumnDef="finalQuantityBalance">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-final"
          >
            CANT.
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number td-group-final font-bold"
            [ngClass]="{
              'text-negative': movementRecord.finalQuantityBalance < 0,
            }"
          >
            {{ formatAccountingQuantity(movementRecord.finalQuantityBalance) }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-final font-bold"
            [ngClass]="{ 'text-negative': currentStockQuantityBalance < 0 }"
          >
            {{ formatAccountingQuantity(currentStockQuantityBalance) }}
          </td>
        </ng-container>

        <!-- SALDO FINAL: Unit Price (CUP) -->
        <ng-container matColumnDef="finalWeightedAverageUnitPrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-final"
          >
            COS. UNIT. (CUP)
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number td-group-final font-bold text-cup"
          >
            S/
            {{ movementRecord.finalWeightedAverageUnitPrice | number: "1.4-4" }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-final font-bold text-cup"
          >
            S/ {{ currentWeightedAverageUnitPriceCUP | number: "1.4-4" }}
          </td>
        </ng-container>

        <!-- SALDO FINAL: Total Valuation Balance -->
        <ng-container matColumnDef="finalTotalValuationBalance">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-final"
          >
            COSTO TOTAL
          </th>
          <td
            mat-cell
            *matCellDef="let movementRecord"
            class="td-number td-group-final font-bold"
            [ngClass]="{
              'text-negative': movementRecord.finalTotalValuationBalance < 0,
            }"
          >
            {{
              formatAccountingCurrency(
                movementRecord.finalTotalValuationBalance
              )
            }}
          </td>
          <td
            mat-footer-cell
            *matFooterCellDef
            class="td-number td-group-final font-bold"
            [ngClass]="{
              'text-negative': currentTotalInventoryValuationBalance < 0,
            }"
          >
            {{
              formatAccountingCurrency(currentTotalInventoryValuationBalance)
            }}
          </td>
        </ng-container>

        <!-- Top Totals Summary Row Columns (for Header Group) -->
        <ng-container matColumnDef="top-total-label">
          <th
            mat-header-cell
            *matHeaderCellDef
            [attr.colspan]="4"
            class="th-center font-bold text-summary"
          >
            TOTAL x ARTÍCULO:
          </th>
        </ng-container>

        <ng-container matColumnDef="top-total-inflowQuantity">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-inflow font-bold"
            [ngClass]="
              periodInflowQuantitySum < 0 ? 'text-negative' : 'text-positive'
            "
          >
            {{
              periodInflowQuantitySum !== 0
                ? formatAccountingQuantity(periodInflowQuantitySum)
                : "-"
            }}
          </th>
        </ng-container>

        <ng-container matColumnDef="top-total-inflowUnitPrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-inflow"
          ></th>
        </ng-container>

        <ng-container matColumnDef="top-total-inflowTotalAmount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-inflow font-bold"
            [ngClass]="periodInflowCostSum < 0 ? 'text-negative' : ''"
          >
            {{
              periodInflowCostSum !== 0
                ? formatAccountingCurrency(periodInflowCostSum)
                : "-"
            }}
          </th>
        </ng-container>

        <ng-container matColumnDef="top-total-outflowQuantity">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-outflow font-bold text-negative"
          >
            {{
              periodOutflowQuantitySum > 0
                ? (periodOutflowQuantitySum | number: "1.2-2")
                : "-"
            }}
          </th>
        </ng-container>

        <ng-container matColumnDef="top-total-outflowUnitPrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-outflow"
          ></th>
        </ng-container>

        <ng-container matColumnDef="top-total-outflowTotalAmount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-outflow font-bold"
          >
            {{
              periodOutflowCostSum > 0
                ? "S/ " + (periodOutflowCostSum | number: "1.2-2")
                : "-"
            }}
          </th>
        </ng-container>

        <ng-container matColumnDef="top-total-finalQuantityBalance">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-final font-bold"
            [ngClass]="{ 'text-negative': currentStockQuantityBalance < 0 }"
          >
            {{ formatAccountingQuantity(currentStockQuantityBalance) }}
          </th>
        </ng-container>

        <ng-container matColumnDef="top-total-finalWeightedAverageUnitPrice">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-final font-bold text-cup"
          >
            S/ {{ currentWeightedAverageUnitPriceCUP | number: "1.4-4" }}
          </th>
        </ng-container>

        <ng-container matColumnDef="top-total-finalTotalValuationBalance">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="th-number th-group-final font-bold"
            [ngClass]="{
              'text-negative': currentTotalInventoryValuationBalance < 0,
            }"
          >
            {{
              formatAccountingCurrency(currentTotalInventoryValuationBalance)
            }}
          </th>
        </ng-container>

        <!-- Top Group Header Definitions -->
        <ng-container matColumnDef="header-doc-group">
          <th
            mat-header-cell
            *matHeaderCellDef
            [attr.colspan]="4"
            class="th-super-header th-super-doc"
          >
            DOCUMENTO TRASLADO / DETALLE
          </th>
        </ng-container>

        <ng-container matColumnDef="header-inflow-group">
          <th
            mat-header-cell
            *matHeaderCellDef
            [attr.colspan]="3"
            class="th-super-header th-super-inflow"
          >
            ENTRADAS
          </th>
        </ng-container>

        <ng-container matColumnDef="header-outflow-group">
          <th
            mat-header-cell
            *matHeaderCellDef
            [attr.colspan]="3"
            class="th-super-header th-super-outflow"
          >
            SALIDAS
          </th>
        </ng-container>

        <ng-container matColumnDef="header-final-group">
          <th
            mat-header-cell
            *matHeaderCellDef
            [attr.colspan]="3"
            class="th-super-header th-super-final"
          >
            SALDO FINAL
          </th>
        </ng-container>

        <!-- Header Row 1: Section Super Headers -->
        <tr
          mat-header-row
          *matHeaderRowDef="[
            'header-doc-group',
            'header-inflow-group',
            'header-outflow-group',
            'header-final-group',
          ]"
          class="tr-super-header"
        ></tr>

        <!-- Header Row 2: Sub-column Headers -->
        <tr
          mat-header-row
          *matHeaderRowDef="kardexTableDisplayedColumns"
          class="tr-sub-header"
        ></tr>

        <!-- Header Row 3: Top Totals Row (Visible when dateSortDirection === 'asc', i.e. Newest at Top) -->
        <tr
          mat-header-row
          *matHeaderRowDef="kardexTableTopTotalsColumns"
          class="tr-footer-totals tr-top-totals"
          [style.display]="dateSortDirection === 'asc' ? '' : 'none'"
        ></tr>

        <!-- Data Rows -->
        <tr
          mat-row
          *matRowDef="let row; columns: kardexTableDisplayedColumns"
          class="tr-data-row"
        ></tr>

        <!-- Footer Summary Row (Visible when dateSortDirection === 'desc', i.e. Oldest at Top) -->
        <tr
          mat-footer-row
          *matFooterRowDef="kardexTableDisplayedColumns"
          class="tr-footer-totals"
          [style.display]="dateSortDirection === 'desc' ? '' : 'none'"
        ></tr>
      </table>
    </div>
  </div>
</div>
